import {useCallback, useContext, useState} from "react";

import {QuickReplyService} from "../../../services/quickReply";
import HTTPContext from "../../contexts/HTTPContext";

export function useChatGPT(reservationId: string) {
    const http = useContext(HTTPContext);
    const [isGeneratingResponse, setIsGeneratingResponse] = useState(false);

    const generateMessage = useCallback(async () => {
        setIsGeneratingResponse(true);
        try {
            const quickReplyService = new QuickReplyService(http);
            const message = await quickReplyService.fetchSuggestion(reservationId);
            return message;
        } finally {
            setIsGeneratingResponse(false);
        }
    }, [http, reservationId]);

    return {
        generateMessage,
        isGeneratingResponse
    };
}
